import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';
import { CometChatService } from '../../../../../core/services/cometChat/cometChat.service';

@Component({
  selector: 'app-captain-context',
  templateUrl: './captain.component.html',
  styleUrls: ['./captain.component.scss'],
})
export class CaptainContextComponent implements OnDestroy {
  cometChatServiceProvider;
  subs: Subscription[] = [];

  constructor(private cometChatService: CometChatService) {}

  async ngOnInit() {
    await this.initContext();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  private async initContext(): Promise<void> {
    try {
      await this.cometChatService.login();
      this.cometChatServiceProvider = this.cometChatService;
    } catch (err) {
      console.error('Failed to initialize context:', err);
    }
  }
}
